import { Api } from '@/core/api.js'
const api = new Api()
import Vue from 'vue'

const state = {
    customers: [],
    meta: {
        page: 1,
        per_page: 20,
        total_customers: 0,
        total_pages: 0
    },
    kpis: {
        customers: 0,
        import: 0,
        bills: 0
    },
    customersFilters: {},
    customersFiltersActive: {
        date: 'month',
        customers: 'admin.filters.all_customers',
        start_date: undefined,
        end_date: undefined,
        search: ''
    }
}

const getters = {
    getCustomers: (state) => () => state.customers,
    getCustomersMeta: (state) => state.meta,
    getCustomersKpis: (state) => state.kpis,
    getCustomersFilters: (state) => state.customersFilters,
    getCustomersFiltersActive: (state) => state.customersFiltersActive
}

const actions = {
    loadCustomers(context, params) {
        return api
            .post(`admin/client/list`, params)
            .then((response) => {
                if (response.status) {
                    context.commit('setCustomers', response.data || [])
                    context.commit('setCustomersMeta', response.meta || {})
                    context.commit('setCustomersKpis', response.kpis || {})
                } else {
                    context.commit('setCustomers', [])
                    context.commit('setCustomersMeta', { page: 1, per_page: params.per_page || 20, total_customers: 0, total_pages: 0 })
                    context.commit('setCustomersKpis', { customers: 0, import: 0, bills: 0 })
                }
                return response
            })
            .catch((error) => {
                return error
            })
    },

    loadFiltersCustomers(context) {
        return api
            .get(`admin/client/filters`)
            .then((response) => {
                if (response.status) {
                    context.commit('setCustomersFilters', response.data)
                }
                return response
            })
            .catch((error) => {
                return error
            })
    },

    downloadPDF(context, params) {
        return api
            .post(`admin/client/list/download/pdf`, params)
            .then((response) => {
                if (response.status) return response.data
                return response
            })
            .catch((error) => {
                return error
            })
    },

    downloadEXCEL(context, params) {
        return api
            .post(`admin/client/list/download/excel`, params)
            .then((response) => {
                if (response.status) return response.data
                return response
            })
            .catch((error) => {
                return error
            })
    },

    downloadXML(context, params) {
        return api
            .post(`admin/client/list/download/xml`, params)
            .then((response) => {
                if (response.status) return response.data
                return response
            })
            .catch((error) => {
                return error
            })
    },
}

const mutations = {
    setCustomers: (state, value) => {
        state.customers = value
        Vue.set(state, 'customers', value)
    },

    setCustomersMeta: (state, value) => {
        state.meta = {
            ...state.meta,
            ...value
        }
        Vue.set(state, 'meta', state.meta)
    },

    setCustomersKpis: (state, value) => {
        state.kpis = {
            ...state.kpis,
            ...value
        }
        Vue.set(state, 'kpis', state.kpis)
    },

    setCustomersFilters: (state, value) => {
        state.customersFilters = value
        Vue.set(state, 'customersFilters', value)
    },

    setCustomersFiltersActive: (state, value) => {
        state.customersFiltersActive = value
        Vue.set(state, 'customersFiltersActive', value)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
